export const APP_NAME = 'Backoffice Loja Solfácil';
export const APP_DESCRIPTION = 'Backoffice da Loja';
